import { render, staticRenderFns } from "./MiniTCDCEdit.vue?vue&type=template&id=2c914c3e&scoped=true"
import script from "./MiniTCDCEdit.vue?vue&type=script&lang=js"
export * from "./MiniTCDCEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c914c3e",
  null
  
)

export default component.exports